// node modules
import { observable, action } from 'mobx';

export default class AuthStore {
  // is auth flow initialized
  @observable initialized = false;
  // charts, WS token

  @action setInitialization = (value: boolean) => {
    this.initialized = value;
  };
}
